import { render, staticRenderFns } from "./saved-profiles.vue?vue&type=template&id=1150fd0a&lang=html&"
import script from "./saved-profiles.vue?vue&type=script&lang=js&"
export * from "./saved-profiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports